import logger from '../../helpers/logger';
import { kioDeviceListeners, DeviceCmdResultData } from '../devices';
import LedBoardDevice, { LedChannel } from './LedBoardDevice';

const CARRIAGE_RETURN_HEX = '0D';

export default class LedBoard implements LedBoardDevice {
	constructor(private deviceName: string) {
		kioDeviceListeners.push(this.onKioDeviceCmdResult.bind(this));
	}

	private asciiCommandToHex(command: string): string {
		const bodyHex = Array.from(command)
			.map((char) => char.charCodeAt(0).toString(16).padStart(2, '0').toUpperCase())
			.join('');
		return `${bodyHex}${CARRIAGE_RETURN_HEX}`;
	}

	private sendCommand(command: string): void {
		window.KioCustomSerialDevice.WriteHex(this.asciiCommandToHex(command), false, undefined, this.deviceName);
	}

	isOpen(): boolean {
		return window.KioCustomSerialDevice.IsOpen(this.deviceName);
	}

	setAllColor(channel: LedChannel, color: string): void {
		this.sendCommand(`${channel},1,${color}`);
	}

	setOutputOn(outputNumber: number): void {
		this.sendCommand(`L${outputNumber}O`);
	}

	setOutputOff(outputNumber: number): void {
		this.sendCommand(`L${outputNumber}F`);
	}

	private onKioDeviceCmdResult(deviceName: string, _id: number, _cmd: number, err: number, data: DeviceCmdResultData): void {
		if (this.deviceName !== deviceName) return;
		if (err !== 0) logger.logGeneral.error({}, `LED board command failed with error code ${err}`, JSON.stringify(data));
	}
}

export class LedBoardStub implements LedBoardDevice {
	constructor(private deviceName: string) {}

	isOpen(): boolean {
		return true;
	}

	setAllColor(channel: LedChannel, color: string): void {
		logger.debug.log(`[LedBoardStub:${this.deviceName}] setAllColor(${channel}, ${color})`);
	}

	setOutputOn(outputNumber: number): void {
		logger.debug.log(`[LedBoardStub:${this.deviceName}] setOutputOn(${outputNumber})`);
	}

	setOutputOff(outputNumber: number): void {
		logger.debug.log(`[LedBoardStub:${this.deviceName}] setOutputOff(${outputNumber})`);
	}
}
